import { HeaderCurrency } from "./card-components";

export const Currency = ({ currency = "" }) => {
  return (
    <HeaderCurrency>
      {currency && currency.length > 0 ? currency : "Валют нет :("}
    </HeaderCurrency>
  );
};
